import React from "react";
import Page from "../components/Page";
import { useSelector } from "react-redux";
import { useParams, Navigate } from "react-router-dom";
import { usePullEntry } from "../hooks/usePullEntry";
import RichText from "../components/RichText";
import LoadingPage from "./LoadingPage";
import LoginPage from "./LoginPage";

function NewsletterDetailPage() {
  const { data } = useSelector((state) => state.cms);
  const { user } = useSelector((state) => state.auth);
  let { id } = useParams();

  const collectionSlug = "newsletters";
  const entryData = usePullEntry(collectionSlug, data, id);

  if (!user) return <LoginPage />;
  if (!entryData) return <LoadingPage />;

  // Check if user has access to this newsletter
  const hasAccess = entryData.role?.some(roleObj => 
    roleObj.Role === "Public" || roleObj.Role === user.currentRole
  );
  if (!hasAccess) return <Navigate to="/newsletters" />;

  return (
    <Page data-wf-page="63598b985c738539af704f12" data-wf-site="634efd6b20b65bfc05be44e4">
      <div className="section wf-section">
        <div className="container fillwhite containerpadding w-container">
          {entryData.photo && entryData.photo.data && (
            <img
              src={entryData.photo.data.attributes.url}
              loading="lazy"
              id="w-node-b1f9418d-a24c-37a0-1829-678c384accc4-af704f12"
              className="imagerounded"
              alt=""
            />
          )}
          <div id="w-node-b1f9418d-a24c-37a0-1829-678c384accc5-af704f12">
            <h3 id="w-node-b1f9418d-a24c-37a0-1829-678c384accc6-af704f12" className="textcenter">
              {entryData.title}
            </h3>
            <RichText text={entryData.body} />
          </div>
        </div>
      </div>
    </Page>
  );
}

export default NewsletterDetailPage;